if (!customElements.get('sector-search-cta')) {
  class SectorSearchCta extends HTMLElement {
    constructor() {
      super();
      this.searchLink = this.querySelector('[data-sector-search-trigger]');
      this.searchLink?.addEventListener('click', this.openSearch.bind(this));
    }

    showSearchSpotlight(searchInput) {
      this.hideSearchSpotlight();

      this.searchInput = searchInput;
      this.searchContainer = searchInput.closest('predictive-search')
        || searchInput.closest('.header__search');
      this.searchOverlay = this.searchContainer?.querySelector('.js-search-overlay');

      if (!this.searchContainer || !this.searchOverlay) return;

      this.searchContainer.classList.add('sector-search-is-spotlighted');

      this.inputHandler = this.hideSearchSpotlight.bind(this);
      this.overlayHandler = this.hideSearchSpotlight.bind(this);
      this.keydownHandler = (keydownEvent) => {
        if (keydownEvent.key === 'Escape') this.hideSearchSpotlight();
      };

      this.searchInput.addEventListener('input', this.inputHandler, { once: true });
      this.searchOverlay.addEventListener('click', this.overlayHandler, { once: true });
      document.addEventListener('keydown', this.keydownHandler);
    }

    hideSearchSpotlight() {
      this.searchContainer?.classList.remove('sector-search-is-spotlighted');
      this.searchInput?.removeEventListener('input', this.inputHandler);
      this.searchOverlay?.removeEventListener('click', this.overlayHandler);
      document.removeEventListener('keydown', this.keydownHandler);

      this.searchInput = null;
      this.searchContainer = null;
      this.searchOverlay = null;
      this.inputHandler = null;
      this.overlayHandler = null;
      this.keydownHandler = null;
    }

    openSearch(event) {
      const header = document.querySelector('store-header');
      const searchInput = header?.querySelector('.js-search-input');

      if (!header || !searchInput) return;

      event.preventDefault();

      // Put the header search fully in view before opening it. Using an instant
      // scroll prevents the page from continuing to move while the customer
      // starts typing into predictive search.
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

      this.showSearchSpotlight(searchInput);

      if (header.classList.contains('search-is-collapsed')) {
        const searchToggles = header.querySelectorAll('.js-show-search, .js-show-search-left');
        const visibleToggle = [...searchToggles].find((toggle) => toggle.getClientRects().length > 0);
        const searchToggle = visibleToggle || searchToggles[0];

        if (searchToggle) {
          searchToggle.click();
        } else {
          searchInput.focus();
        }
        return;
      }

      searchInput.focus({ preventScroll: true });
    }
  }

  customElements.define('sector-search-cta', SectorSearchCta);
}
